/* eslint-disable import/named */
import DSCircularProgressIndicator from './DSCircularProgressIndicator.js';

export { CircularProgressIndicatorWithSchema } from './DSCircularProgressIndicator.js';
export {
  DSCircularIndeterminateIndicator,
  DSCircularIndeterminateIndicatorWithSchema,
  DSCircularIndeterminateIndicatorName,
  DSCircularIndeterminateIndicatorSlots,
  DSCircularIndeterminateIndicatorDataTestIds,
} from './v2/index.js';

export { DSCircularProgressIndicator };
export default DSCircularProgressIndicator;
